module.exports = __webpack_public_path__ + "static/49-47189018fd09b3c05757c4fbcc2889ff.png";